import MafiaGameState from '../logic/mafia/MafiaGameState';

const clonePlayers = (players = []) => players.map((player) => ({ ...player }));

export const serializeMafiaGameState = (gameState) => {
    if (!gameState) return null;

    return {
        players: clonePlayers(gameState.players),
        phase: gameState.phase,
        nightStep: gameState.nightStep,
        roundNumber: gameState.roundNumber,
        discussionTime: gameState.discussionTime,
        killedThisNight: gameState.killedThisNight?.name || null,
        revivedThisNight: gameState.revivedThisNight?.name || null,
        suspectedThisDay: gameState.suspectedThisDay?.name || null,
        votedOutThisDay: gameState.votedOutThisDay?.name || null,
        mafiaActionTaken: Boolean(gameState.mafiaActionTaken),
        doctorActionTaken: Boolean(gameState.doctorActionTaken),
        detectiveActionTaken: Boolean(gameState.detectiveActionTaken),
        doctorHasSavedSelf: Boolean(gameState.doctorHasSavedSelf),
        lastAction: gameState.lastAction ? { ...gameState.lastAction } : null,
        gameOver: Boolean(gameState.gameOver),
        winner: gameState.winner || null
    };
};

export const hydrateMafiaGameState = (serializedState) => {
    if (!serializedState) return null;

    const hydrated = Object.create(MafiaGameState.prototype);
    Object.assign(hydrated, serializedState);
    hydrated.players = clonePlayers(serializedState.players);

    const playersByName = new Map(hydrated.players.map((player) => [player.name, player]));
    hydrated.killedThisNight = serializedState.killedThisNight ? (playersByName.get(serializedState.killedThisNight) || null) : null;
    hydrated.revivedThisNight = serializedState.revivedThisNight ? (playersByName.get(serializedState.revivedThisNight) || null) : null;
    hydrated.suspectedThisDay = serializedState.suspectedThisDay ? (playersByName.get(serializedState.suspectedThisDay) || null) : null;
    hydrated.votedOutThisDay = serializedState.votedOutThisDay ? (playersByName.get(serializedState.votedOutThisDay) || null) : null;

    return hydrated;
};
